import React, { useState, useRef, useEffect } from 'react';
import {
  getMachineRequestReport,
  getPurchaseOrderReport,
  getInstallationReport,
  getServiceRemainderReport,
  getBreakdownReport,
  getSec,
} from '../../services/mm/apiController';
import { Table, Form, FloatingLabel, Row, Col } from 'react-bootstrap';
import { formatDate } from '../../util/helper';
import { toast, ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import FactoryDropdown from '../vm/FactoryDropdown';
import { useSelector } from 'react-redux';
import { factoryId } from '../../store/reducers/account_reducer';
import { getStoredData, get_auth_key } from '../../util';

const Report = () => {
  const factoryId_ = useSelector(factoryId);
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  const [value, setValue] = useState({ reportType: '' });
  const clickToDownload = useRef(null);
  const formFields = { startDate: '', endDate: '', model: '', status: '', section: '', initiatedBy: '' };
  const PoFormFields = { startDate: '', endDate: '', poNumber: '', item: '', section: '', initiatedBy: '' };
  const installationFormFields = { startDate: '', endDate: '', item: '', itemNumber: '', section: '' };
  const serviceRemainderFormFields = {
    startDate: '',
    endDate: '',
    name: '',
    servicedStartDate: '',
    servicedEndDate: '',
    serviceStatus: '',
    section: '',
  };
  const breakdownFormFields = {
    startDate: '',
    endDate: '',
    name: '',
    servicedStartDate: '',
    servicedEndDate: '',
    breakdownStatus: '',
    section: '',
  };
  const [machineRequestForm, setMachineRequestForm] = useState(formFields);
  const [sections, setSections] = useState([]);
  const [POForm, setPOForm] = useState(PoFormFields);
  const [installationForm, setInstallationForm] = useState(installationFormFields);
  const [serviceRemainderForm, setServiceRemainderForm] = useState(serviceRemainderFormFields);
  const [breakdownForm, setBreakdownForm] = useState(breakdownFormFields);
  const [machineReq, setMachineReq] = useState('');
  const [purchaseOrder, setPurchaseOrder] = useState('');
  const [installation, setInstallation] = useState('');
  const [serviceRemainder, setServiceRemainder] = useState('');
  const [breakdown, setBreakdown] = useState('');

  const handleSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setValue({ [name]: value });
    setMachineReq('');
    setPurchaseOrder('');
    setInstallation('');
    setServiceRemainder('');
    setBreakdown('');
  };

  const handleVehicleChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setMachineRequestForm({ ...machineRequestForm, [name]: value });
  };

  const handlePOChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setPOForm({ ...POForm, [name]: value });
  };

  const handleRunningVehiclChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setInstallationForm({ ...installationForm, [name]: value });
  };

  const handleServiceRemainderChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setServiceRemainderForm({ ...serviceRemainderForm, [name]: value });
  };

  const handleBreakdownChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setBreakdownForm({ ...breakdownForm, [name]: value });
  };

  const handleBreakdownSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setBreakdownForm({ ...breakdownForm, [name]: value });
  };

  const handleServiceRemainderSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setServiceRemainderForm({ ...serviceRemainderForm, [name]: value });
  };

  const handleVehicleSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setMachineRequestForm({ ...machineRequestForm, [name]: value });
  };
  const handleSectionSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setPOForm({ ...POForm, [name]: value });
  };
  const handleInstaSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setInstallationForm({ ...installationForm, [name]: value });
  };

  async function getSections() {
    const data = await getSec(factoryId_);
    setSections(data.data);
  }

  useEffect(() => {
    getSections();
  }, [factoryId_]);

  const handleSubmit = async (e, conditionType) => {
    e.preventDefault();
    if (value.reportType === 'Machine')
      try {
        if (conditionType === 'download') {
          const requestOptions = {
            method: 'GET',
            headers: {
              'x-access-token': storedData.token,
            },
          };
          const response = await fetch(
            `${process.env.REACT_APP_BASE_URL}/mm/machine/generate/reports?factoryId=${factoryId_}&startDate=${machineRequestForm.startDate}&endDate=${machineRequestForm.endDate}&name=${machineRequestForm.model}&section=${machineRequestForm.section}&status=${machineRequestForm.status}&initiatedBy=${machineRequestForm.initiatedBy}`,
            requestOptions
          );
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          clickToDownload.current.href = url;
          clickToDownload.current.setAttribute('download', 'Machine report.pdf');
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        } else {
          const data = await getMachineRequestReport(
            factoryId_,
            machineRequestForm.startDate,
            machineRequestForm.endDate,
            machineRequestForm.model,
            machineRequestForm.status,
            machineRequestForm.section,
            machineRequestForm.initiatedBy,
            conditionType
          );
          setMachineReq(data.data);
        }
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      }
    if (value.reportType === 'PO')
      try {
        if (conditionType === 'download') {
          const requestOptions = {
            method: 'GET',
            headers: {
              'x-access-token': storedData.token,
            },
          };
          const response = await fetch(
            `${process.env.REACT_APP_BASE_URL}/mm/purchase-order/generate/reports?factoryId=${factoryId_}&startDate=${POForm.startDate}&endDate=${POForm.endDate}&item=${POForm.item}&poNumber=${POForm.poNumber}&section=${POForm.section}&initiatedBy=${POForm.initiatedBy}`,
            requestOptions
          );
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          clickToDownload.current.href = url;
          clickToDownload.current.setAttribute('download', 'PO report.pdf');
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        } else {
          const data = await getPurchaseOrderReport(
            factoryId_,
            POForm.startDate,
            POForm.endDate,
            POForm.item,
            POForm.poNumber,
            POForm.section,
            POForm.initiatedBy,
            conditionType
          );
          await setPurchaseOrder(data.data);
        }
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      }
    if (value.reportType === 'Installation')
      try {
        if (conditionType === 'download') {
          const requestOptions = {
            method: 'GET',
            headers: {
              'x-access-token': storedData.token,
            },
          };
          const response = await fetch(
            `${process.env.REACT_APP_BASE_URL}/mm/installation/generate/reports?factoryId=${factoryId_}&startDate=${installationForm.startDate}&endDate=${installationForm.endDate}&item=${installationForm.item}&itemNumber=${installationForm.itemNumber}&section=${installationForm.section}`,
            requestOptions
          );
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          clickToDownload.current.href = url;
          clickToDownload.current.setAttribute('download', 'Installation report.pdf');
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        } else {
          const data = await getInstallationReport(
            factoryId_,
            installationForm.startDate,
            installationForm.endDate,
            installationForm.item,
            installationForm.itemNumber,
            installationForm.section,
            conditionType
          );
          setInstallation(data.data);
        }
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      }
    if (value.reportType === 'service')
      try {
        if (conditionType === 'download') {
          const requestOptions = {
            method: 'GET',
            headers: {
              'x-access-token': storedData.token,
            },
          };
          const response = await fetch(
            `${process.env.REACT_APP_BASE_URL}/mm/service-remainder/generate/reports?factoryId=${factoryId_}&startDate=${serviceRemainderForm.startDate}&endDate=${serviceRemainderForm.endDate}&name=${serviceRemainderForm.name}&servicedStartDate=${serviceRemainderForm.servicedStartDate}&servicedEndDate=${serviceRemainderForm.servicedEndDate}&serviceStatus=${serviceRemainderForm.serviceStatus}&section=${serviceRemainderForm.section}`,
            requestOptions
          );
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          clickToDownload.current.href = url;
          clickToDownload.current.setAttribute('download', 'Service report.pdf');
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        } else {
          const data = await getServiceRemainderReport(
            factoryId_,
            serviceRemainderForm.startDate,
            serviceRemainderForm.endDate,
            serviceRemainderForm.name,
            serviceRemainderForm.servicedStartDate,
            serviceRemainderForm.servicedEndDate,
            serviceRemainderForm.serviceStatus,
            serviceRemainderForm.section,
            conditionType
          );
          setServiceRemainder(data.data);
        }
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      }
    if (value.reportType === 'breakdown')
      try {
        if (conditionType === 'download') {
          const requestOptions = {
            method: 'GET',
            headers: {
              'x-access-token': storedData.token,
            },
          };
          const response = await fetch(
            `${process.env.REACT_APP_BASE_URL}/mm/breakdown/generate/reports?factoryId=${factoryId_}&startDate=${breakdownForm.startDate}&endDate=${breakdownForm.endDate}&name=${breakdownForm.name}&servicedStartDate=${breakdownForm.servicedStartDate}&servicedEndDate=${breakdownForm.servicedEndDate}&repairStatus=${breakdownForm.breakdownStatus}&section=${breakdownForm.section}`,
            requestOptions
          );
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          clickToDownload.current.href = url;
          clickToDownload.current.setAttribute('download', 'Breakdown report.pdf');
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        } else {
          const data = await getBreakdownReport(
            factoryId_,
            breakdownForm.startDate,
            breakdownForm.endDate,
            breakdownForm.name,
            breakdownForm.servicedStartDate,
            breakdownForm.servicedEndDate,
            breakdownForm.breakdownStatus,
            breakdownForm.section,
            conditionType
          );
          setBreakdown(data.data);
        }
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <nav className="" aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/machine-requests">Reports</Link>
          </li>
        </ol>
      </nav>
      <div className="card top-card">
        <div className="card-body">
          <div className="row">
            <FactoryDropdown />
            <div className="form-group col-md-4 col-lg-4">
              <label htmlFor="exampleInputEmail1">Report For</label>
              <Form.Select
                value={value.reportType}
                onChange={handleSelect}
                name="reportType"
                aria-label="Select from which module you need to fetch report"
                required
              >
                <option>Select</option>
                <option value="Machine">Machine</option>
                <option value="PO">Purchase Order</option>
                <option value="Installation">Installation</option>
                <option value="service">Service Remainders</option>
                <option value="breakdown">Breakdown</option>
              </Form.Select>
            </div>
            {factoryId_ ? (
              <>
                {value.reportType === 'Machine' ? (
                  <>
                    <div className="col-12 blockLine my-3">
                      <p className="my-0">
                        <strong>Filter criteria</strong>
                      </p>
                      <hr className="my-0" />
                    </div>
                    <Form className="mt-4">
                      <Row>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Start Date" className="mb-3">
                            <Form.Control
                              onChange={handleVehicleChange}
                              value={machineRequestForm.startDate}
                              className="input"
                              name="startDate"
                              type="date"
                              placeholder="Start Date"
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="End Date" className="mb-3">
                            <Form.Control
                              onChange={handleVehicleChange}
                              value={machineRequestForm.endDate}
                              className="input"
                              name="endDate"
                              type="date"
                              placeholder="End Date"
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Machine Name" className="mb-3">
                            <Form.Control
                              onChange={handleVehicleChange}
                              value={machineRequestForm.model}
                              className="input"
                              name="model"
                              type="text"
                              placeholder="Vehicle Date"
                            />
                          </FloatingLabel>
                        </Col>
                      </Row>
                      <Row className="mb-4">
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingSelect" label="Status">
                            <Form.Select
                              onChange={handleVehicleSelect}
                              value={machineRequestForm.status}
                              name="status"
                              aria-label="Floating label select example"
                            >
                              <option>Select Status</option>
                              <option value="INITIATED">INITIATED</option>
                              <option value="APPROVED">APPROVED</option>
                              <option value="INSTALLED">INSTALLED</option>
                            </Form.Select>
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingSelect" label="Status">
                            <Form.Select
                              onChange={handleVehicleSelect}
                              value={machineRequestForm.section}
                              name="section"
                              aria-label="Floating label select example"
                            >
                              <option value="">Select Section</option>
                              {Object.keys(sections).map((key) => (
                                <option key={key} value={key.value}>
                                  {sections[key].value}
                                </option>
                              ))}
                            </Form.Select>
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Initiated By" className="mb-3">
                            <Form.Control
                              onChange={handleVehicleChange}
                              value={machineRequestForm.initiatedBy}
                              className="input"
                              name="initiatedBy"
                              type="text"
                              placeholder="Initiated By"
                            />
                          </FloatingLabel>
                        </Col>
                      </Row>
                    </Form>
                  </>
                ) : (
                  ''
                )}
                {value.reportType === 'PO' ? (
                  <>
                    <div className="col-12 blockLine my-3">
                      <p className="my-0">
                        <strong>Filter criteria</strong>
                      </p>
                      <hr className="my-0" />
                    </div>
                    <Form className="mt-4">
                      <Row>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Start Date" className="mb-3">
                            <Form.Control
                              onChange={handlePOChange}
                              value={POForm.startDate}
                              className="input"
                              name="startDate"
                              type="date"
                              placeholder="Start Date"
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="End Date" className="mb-3">
                            <Form.Control
                              onChange={handlePOChange}
                              value={POForm.endDate}
                              className="input"
                              name="endDate"
                              type="date"
                              placeholder="End Date"
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Purchase Number" className="mb-3">
                            <Form.Control
                              onChange={handlePOChange}
                              value={POForm.poNumber}
                              className="input"
                              name="poNumber"
                              type="text"
                              placeholder="Purchase Number"
                            />
                          </FloatingLabel>
                        </Col>
                      </Row>
                      <Row className="mb-4">
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Machine Name" className="mb-3">
                            <Form.Control
                              onChange={handlePOChange}
                              value={POForm.item}
                              className="input"
                              name="item"
                              type="text"
                              placeholder="Machine Name"
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingSelect" label="Section">
                            <Form.Select
                              onChange={handleSectionSelect}
                              value={POForm.section}
                              name="section"
                              aria-label="Floating label select example"
                            >
                              <option value="">Select Section</option>
                              {Object.keys(sections).map((key) => (
                                <option key={key} value={key.value}>
                                  {sections[key].value}
                                </option>
                              ))}
                            </Form.Select>
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Approved By" className="mb-3">
                            <Form.Control
                              onChange={handlePOChange}
                              value={POForm.initiatedBy}
                              className="input"
                              name="initiatedBy"
                              type="text"
                              placeholder="Approved By"
                            />
                          </FloatingLabel>
                        </Col>
                      </Row>
                    </Form>
                  </>
                ) : (
                  ''
                )}
                {value.reportType === 'Installation' ? (
                  <>
                    <div className="col-12 blockLine my-3">
                      <p className="my-0">
                        <strong>Filter criteria</strong>
                      </p>
                      <hr className="my-0" />
                    </div>
                    <Form className="mt-4">
                      <Row>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Start Date" className="mb-3">
                            <Form.Control
                              onChange={handleRunningVehiclChange}
                              value={installationForm.startDate}
                              className="input"
                              name="startDate"
                              type="date"
                              placeholder="Start Date"
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="End Date" className="mb-3">
                            <Form.Control
                              onChange={handleRunningVehiclChange}
                              value={installationForm.endDate}
                              className="input"
                              name="endDate"
                              type="date"
                              placeholder="End Date"
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Machine Name" className="mb-3">
                            <Form.Control
                              onChange={handleRunningVehiclChange}
                              value={installationForm.item}
                              className="input"
                              name="item"
                              type="text"
                              placeholder="Machine Name"
                            />
                          </FloatingLabel>
                        </Col>
                      </Row>
                      <Row className="mb-4">
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Model Number" className="mb-3">
                            <Form.Control
                              onChange={handleRunningVehiclChange}
                              value={installationForm.itemNumber}
                              className="input"
                              name="itemNumber"
                              type="text"
                              placeholder="Model Number"
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingSelect" label="Section">
                            <Form.Select
                              onChange={handleInstaSelect}
                              value={installationForm.section}
                              name="section"
                              aria-label="Floating label select example"
                            >
                              <option value="">Select Section</option>
                              {Object.keys(sections).map((key) => (
                                <option key={key} value={key.value}>
                                  {sections[key].value}
                                </option>
                              ))}
                            </Form.Select>
                          </FloatingLabel>
                        </Col>
                      </Row>
                    </Form>
                  </>
                ) : (
                  ''
                )}
                {value.reportType === 'service' ? (
                  <>
                    <div className="col-12 blockLine my-3">
                      <p className="my-0">
                        <strong>Filter criteria</strong>
                      </p>
                      <hr className="my-0" />
                    </div>
                    <Form className="mt-4">
                      <Row>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Start Date" className="mb-3">
                            <Form.Control
                              onChange={handleServiceRemainderChange}
                              value={serviceRemainderForm.startDate}
                              className="input"
                              name="startDate"
                              type="date"
                              placeholder="Start Date"
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="End Date" className="mb-3">
                            <Form.Control
                              onChange={handleServiceRemainderChange}
                              value={serviceRemainderForm.endDate}
                              className="input"
                              name="endDate"
                              type="date"
                              placeholder="End Date"
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Machine Name" className="mb-3">
                            <Form.Control
                              onChange={handleServiceRemainderChange}
                              value={serviceRemainderForm.name}
                              className="input"
                              name="name"
                              type="text"
                              placeholder="Machine Name"
                            />
                          </FloatingLabel>
                        </Col>
                      </Row>
                      <Row className="mb-4">
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Serviced Start Date" className="mb-3">
                            <Form.Control
                              onChange={handleServiceRemainderChange}
                              value={serviceRemainderForm.servicedStartDate}
                              className="input"
                              name="servicedStartDate"
                              type="date"
                              placeholder="Serviced Start Date"
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Serviced End Date" className="mb-3">
                            <Form.Control
                              onChange={handleServiceRemainderChange}
                              value={serviceRemainderForm.servicedEndDate}
                              className="input"
                              name="servicedEndDate"
                              type="date"
                              placeholder="Serviced End Date"
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingSelect" label="Service Status">
                            <Form.Select
                              onChange={handleServiceRemainderSelect}
                              value={serviceRemainderForm.serviceStatus}
                              name="serviceStatus"
                              aria-label="Floating label select example"
                            >
                              <option value="">Select Service Status</option>
                              <option value="PENDING">Pending</option>
                              <option value="COMPLETED">Completed</option>
                            </Form.Select>
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingSelect" label="Status">
                            <Form.Select
                              onChange={handleServiceRemainderSelect}
                              value={serviceRemainderForm.section}
                              name="section"
                              aria-label="Floating label select example"
                            >
                              <option value="">Select Section</option>
                              {Object.keys(sections).map((key) => (
                                <option key={key} value={key.value}>
                                  {sections[key].value}
                                </option>
                              ))}
                            </Form.Select>
                          </FloatingLabel>
                        </Col>
                      </Row>
                    </Form>
                  </>
                ) : (
                  ''
                )}
                {value.reportType === 'breakdown' ? (
                  <>
                    <div className="col-12 blockLine my-3">
                      <p className="my-0">
                        <strong>Filter criteria</strong>
                      </p>
                      <hr className="my-0" />
                    </div>
                    <Form className="mt-4">
                      <Row>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Start Date" className="mb-3">
                            <Form.Control
                              onChange={handleBreakdownChange}
                              value={breakdownForm.startDate}
                              className="input"
                              name="startDate"
                              type="date"
                              placeholder="Start Date"
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="End Date" className="mb-3">
                            <Form.Control
                              onChange={handleBreakdownChange}
                              value={breakdownForm.endDate}
                              className="input"
                              name="endDate"
                              type="date"
                              placeholder="End Date"
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Machine Name" className="mb-3">
                            <Form.Control
                              onChange={handleBreakdownChange}
                              value={breakdownForm.name}
                              className="input"
                              name="name"
                              type="text"
                              placeholder="Machine Name"
                            />
                          </FloatingLabel>
                        </Col>
                      </Row>
                      <Row className="mb-4">
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Serviced Start Date" className="mb-3">
                            <Form.Control
                              onChange={handleBreakdownChange}
                              value={breakdownForm.servicedStartDate}
                              className="input"
                              name="servicedStartDate"
                              type="date"
                              placeholder="Serviced Start Date"
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Serviced End Date" className="mb-3">
                            <Form.Control
                              onChange={handleBreakdownChange}
                              value={breakdownForm.servicedEndDate}
                              className="input"
                              name="servicedEndDate"
                              type="date"
                              placeholder="Serviced End Date"
                            />
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingSelect" label="Breakdown Status">
                            <Form.Select
                              onChange={handleBreakdownSelect}
                              value={breakdownForm.breakdownStatus}
                              name="breakdownStatus"
                              aria-label="Floating label select example"
                            >
                              <option value="">Select Breakdown Status</option>
                              <option value="PENDING">Pending</option>
                              <option value="REPAIRED">Repaired</option>
                            </Form.Select>
                          </FloatingLabel>
                        </Col>
                        <Col xs={4}>
                          <FloatingLabel controlId="floatingSelect" label="Status">
                            <Form.Select
                              onChange={handleBreakdownSelect}
                              value={breakdownForm.section}
                              name="section"
                              aria-label="Floating label select example"
                            >
                              <option value="">Select Section</option>
                              {Object.keys(sections).map((key) => (
                                <option key={key} value={key.value}>
                                  {sections[key].value}
                                </option>
                              ))}
                            </Form.Select>
                          </FloatingLabel>
                        </Col>
                      </Row>
                    </Form>
                  </>
                ) : (
                  ''
                )}
              </>
            ) : (
              <h4 className="card-title mb-0" style={{ fontSize: '16px', color: 'red' }}>
                Please Select a Factory
              </h4>
            )}
          </div>
        </div>
        {factoryId_ ? (
          <>
            <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
              HiddenClick
            </a>
            <div className="card-footer">
              <div className="btn-wrapper">
                <button
                  onClick={() => {
                    setMachineRequestForm(formFields);
                    setPOForm(PoFormFields);
                    setInstallationForm(installationFormFields);
                    setServiceRemainderForm(serviceRemainderFormFields);
                    setBreakdownForm(breakdownFormFields);
                  }}
                  className="btn app-btn-default"
                >
                  Cancel
                </button>
                <button onClick={(e) => handleSubmit(e, true)} className="btn app-btn-primary">
                  Fetch Report
                </button>
              </div>
            </div>
          </>
        ) : (
          ''
        )}
      </div>
      {factoryId_ ? (
        <>
          {machineReq && Object.keys(machineReq).length !== 0 ? (
            <div className="card">
              <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                  All Machines
                </h4>
                <button type="button" onClick={(e) => handleSubmit(e, 'download')} className="btn app-btn-default dark-color">
                  Download Report
                </button>
              </div>
              <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
                <div className="row">
                  <div className="col">
                    <Table responsive striped>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Machine</th>
                          <th>Section</th>
                          <th>Requested By / Initiated By</th>
                          <th>Status</th>
                          <th>Requested Date</th>
                          <th>Reason</th>
                        </tr>
                      </thead>
                      <tbody>
                        {machineReq?.list?.map((request, index) => {
                          return (
                            <tr key={request?.id}>
                              <td>{index + 1}</td>
                              <td>{request?.model}</td>
                              <td>{request?.section}</td>
                              <td>
                                {request?.requestedBy} / {request?.initiatedBy}
                              </td>
                              <td>{request?.status}</td>
                              <td>{formatDate(request?.requestedDate)}</td>
                              <td>{request?.reason}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
          {purchaseOrder && Object.keys(purchaseOrder).length !== 0 ? (
            <div className="card">
              <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                  All Purchase Order
                </h4>
                <button type="button" onClick={(e) => handleSubmit(e, 'download')} className="btn app-btn-default dark-color">
                  Download Report
                </button>
              </div>
              <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
                <div className="row">
                  <div className="col">
                    <Table responsive striped>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>PO Number</th>
                          <th>Name</th>
                          <th>Section</th>
                          <th>Initiated By</th>
                          <th>Approved Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {purchaseOrder?.list?.map((request, index) => {
                          return (
                            <tr key={request?.id}>
                              <td>{index + 1}</td>
                              <td>{request?.poNumber}</td>
                              <td>{request?.item}</td>
                              <td>{request?.section}</td>
                              <td>{request?.initiatedBy}</td>
                              <td>{formatDate(request?.approvedDate)}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
          {installation && Object.keys(installation).length !== 0 ? (
            <div className="card">
              <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                  All Installed Machine
                </h4>
                <button type="button" onClick={(e) => handleSubmit(e, 'download')} className="btn app-btn-default dark-color">
                  Download Report
                </button>
              </div>
              <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
                <div className="row">
                  <div className="col">
                    <Table responsive striped>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>
                            Item / Asset # <br />
                            Machine Name
                          </th>
                          <th>
                            Section <br />
                            Description
                          </th>
                          <th>Installation Charges</th>
                          <th>Installation Date</th>
                          <th>Location</th>
                        </tr>
                      </thead>
                      <tbody>
                        {installation?.list?.map((request, index) => {
                          return (
                            <tr key={request?.id}>
                              <td>{index + 1}</td>
                              <td>
                                {request?.itemNumber} <br />
                                {request?.item}
                              </td>
                              <td>
                                {request?.section} <br />
                                {request?.description || '-'}
                              </td>
                              <td>{request?.charges}</td>
                              <td>{formatDate(request?.installationDate)}</td>
                              <td>{request?.location}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
          {serviceRemainder && Object.keys(serviceRemainder).length !== 0 ? (
            <div className="card">
              <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                  All Service Remainder
                </h4>
                <button type="button" onClick={(e) => handleSubmit(e, 'download')} className="btn app-btn-default dark-color">
                  Download Report
                </button>
              </div>
              <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
                <div className="row">
                  <div className="col">
                    <Table responsive striped>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Name / Description</th>
                          <th>Machine Name / Section</th>
                          <th>Status / Type</th>
                          <th>Due Date / Serviced Date</th>
                          <th>Technician / Supervised By</th>
                          <th>Labour Cost / Material Cost / Comments</th>
                        </tr>
                      </thead>
                      <tbody>
                        {serviceRemainder?.list?.map((request, index) => {
                          return (
                            <tr key={request?.id}>
                              <td>{index + 1}</td>
                              <td>
                                {request?.name} / {request?.description}
                              </td>
                              <td>
                                {request?.installation?.item} / {request?.installation?.section}
                              </td>
                              <td>
                                {request?.status} / {request?.type}
                              </td>
                              <td>
                                {formatDate(request?.dueDate)} / {formatDate(request?.servicedDate)}
                              </td>
                              <td>
                                {request?.technicianName} / {request?.supervisedBy}
                              </td>
                              <td>
                                {request?.serviceCost} / {request?.materialCost} / {request?.serviceComments}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
          {breakdown && Object.keys(breakdown).length !== 0 ? (
            <div className="card">
              <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                  All Breakdown
                </h4>
                <button type="button" onClick={(e) => handleSubmit(e, 'download')} className="btn app-btn-default dark-color">
                  Download Report
                </button>
              </div>
              <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
                <div className="row">
                  <div className="col">
                    <Table responsive striped>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Reason / Status / Supervised By</th>
                          <th>
                            Machine Name <br />
                            Section
                          </th>
                          <th>Break Date / Serviced Date</th>
                          <th>Technician</th>
                          <th>Labour Cost / Material Cost / Comments</th>
                        </tr>
                      </thead>
                      <tbody>
                        {breakdown?.list?.map((request, index) => {
                          return (
                            <tr key={request?.id}>
                              <td>{index + 1}</td>
                              <td>
                                {request?.reason} / {request?.status} / {request?.supervisedBy}
                              </td>
                              <td>
                                {request?.model} <br />
                                {request?.section}
                              </td>
                              <td>
                                {formatDate(request?.breakDate)} / {formatDate(request?.servicedDate)}
                              </td>
                              <td>
                                {request?.technicianName} <br /> {request?.technicianContactNumber}
                              </td>
                              <td>
                                {request?.serviceCost} / {request?.materialCost} / {request?.serviceComments}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </>
      ) : (
        ''
      )}
    </React.Fragment>
  );
};

export default Report;
